(function () {
    var controllerId = 'host.views.directorDashboard.index';
    var app = angular.module('app');

    app.controller(controllerId, [
        function () {
            var vm = this;
        }
    ]);
})();